export const SET_CHECK = "SET_CHECK";

export const SET_PENDING_REASON = "SET_PENDING_REASON";

export const SET_TEST_STATE = "SET_TEST_STATE";

export const SET_IS_WAITING_TO_LEAVE = "SET_IS_WAITING_TO_LEAVE";

export const SET_IS_CHECK_DEVICE = "SET_IS_CHECK_DEVICE";

export const SET_IS_CHECK_INIT = "SET_IS_CHECK_INIT";
